module.exports = __webpack_public_path__ + "img/Mobile.b7a0bbb2.svg";